"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactionChangedEventArgs = void 0;
const EventType_1 = require("../EventType");
class FactionChangedEventArgs {
    constructor(previous, next) {
        this.previous = previous;
        this.next = next;
        this.__type = EventType_1.EventType.FactionChanged;
        this.__typeName = "FactionChanged";
    }
}
exports.FactionChangedEventArgs = FactionChangedEventArgs;
